module.exports = __webpack_public_path__ + "img/arrow-down.342d6b59.svg";